import { combineReducers } from 'redux';

import sentEvents from './sentEvents/slice';

export * from './sentEvents';

export const analytics = combineReducers({
  sentEvents,
});
